export default __webpack_public_path__ + "static/media/lion_mark.b915c980.png";